import { MantineProvider } from '@mantine/core';
import { DatesProvider } from '@mantine/dates';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import { QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RouterProvider } from 'react-router';
import { onUnauthorized } from '@/api/client';
import { sessionKey } from '@/api/session';
import { PwaUpdatePrompt } from '@/pwa/PwaUpdatePrompt';
import { createQueryClient } from './queryClient';
import { router } from './router';
import { theme } from './theme';

export function App() {
  const { i18n } = useTranslation();
  const [queryClient] = useState(() => {
    const client = createQueryClient();
    onUnauthorized(() => void client.invalidateQueries({ queryKey: sessionKey }));
    return client;
  });

  return (
    <MantineProvider theme={theme} defaultColorScheme="auto">
      <DatesProvider settings={{ locale: i18n.language.startsWith('en') ? 'en' : 'de', firstDayOfWeek: 1 }}>
        <ModalsProvider>
          <Notifications position="bottom-right" />
          <QueryClientProvider client={queryClient}>
            <RouterProvider router={router} />
            <PwaUpdatePrompt />
          </QueryClientProvider>
        </ModalsProvider>
      </DatesProvider>
    </MantineProvider>
  );
}
